import React from 'react';
import { List } from 'immutable';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  Paragraph,
  Node,
  View,
} from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Download,
} from '../../../../components';

import './style.scss';

const HelpPageDetail = ({ entity, className }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const nid = entity.getIn(['nid', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const heroImage = entity.getIn(['field_hero', 0, 'styles', 'original']);

  const contactPerson = entity.getIn(['field_contactperson', 0, 'entity']);
  const downloads = entity.getIn(['field_downloads']);
  const faqItems = entity.getIn(['field_faq']);
  const { t } = useTranslation();

  const helpPageType = entity.getIn(['field_help_page_type', 0, 'entity', 'name', 0, 'value']);
  const heroInnerClasses = c(`NodeHelpPage__hero__inner NodeHelpPage__hero__inner--${helpPageType.toLowerCase()}`);

  return (
    <article className="NodeHelpPage">
      {/* Start of Hero */}
      <Container className="NodeHelpPage__intro">
        <div className="row">
          <div className="col-12 col-md-8 col-lg-7 NodeHelpPage__hero">
            <div className={heroInnerClasses}>
              <h1>{title}</h1>

              <WysiwygField
                property="schema:text"
                html={body}
                className="NodeHelpPage__body"
              />
            </div>
          </div>
          <div className="NodeHelpPage__image__wrapper col-12 col-md-4 col-lg-5 ">
            <Image
              className="NodeHelpPage__image"
              lazyload={false}
              src={heroImage}
            />
          </div>
        </div>
      </Container>
      {/* End of body */}

      <Container>
        <div className="row">
          <div className="col-12 col-lg-8">
            {entity.get('field_paragraphs') ? (
              <div className="NodeHelpPage__paragraphs_wrapper">
                {entity.get('field_paragraphs', List()).map((paragraph) => {
                  const id = paragraph.get('target_id');
                  const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                  return (
                    <div key={`paragraph:${id}:${language}`} id={id} className="ParagraphAnchorWrapper">
                      <Paragraph
                        key={`paragraph:${id}`}
                        id={id}
                        entity={paragraph.get('entity')}
                        containerless
                      />
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
          <div className="col-12 col-lg-4">
            {contactPerson && (
              <Node id={contactPerson.getIn(['nid', 0, 'value'])} entity={contactPerson} />
            )}

            {downloads && downloads.size > 0 && (
              <div className="NodeHelpPage__downloads">
                <h4>{t('pages.help_detail.downloads')}</h4>
                { downloads.map((download, index) => {
                  const downloadTitle = download.get('title');
                  const key = `${downloadTitle}-${index}`;
                  return (
                    <Download key={key} download={download} />
                  );
                })}
              </div>
            )}

            {faqItems && faqItems.size > 0 && (
              <div className="NodeHelpPage__FAQ">
                <h4>{t('pages.help_detail.faq')}</h4>
                {faqItems.map((faq, index) => {
                  const faqEntity = faq.get('entity');
                  if (!faqEntity) {
                    return null;
                  }

                  const faqNid = faqEntity.getIn(['nid', 0, 'value']);
                  return (
                    <Node key={faqNid} id={faqNid} entity={faqEntity} />
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </Container>

      <Container className="NodeHelpPage__other_pages">
        <div className="row">
          <div className="col-12">
            <View
              id="related_help_pages"
              key={`related_help_pages-${nid}`}
              display="block_7"
              readMore="1"
              args={[nid]}
            />
          </div>
        </div>
      </Container>

    </article>
  );
};

export default HelpPageDetail;
